import StatusIcon from "app/components/Icons/StatusIcon";
import CustomTooltip from "app/components/Tooltip";
import React, { FC, useEffect, useState } from "react";
import { GroupByTypeEnum, TicketGroup } from "../types";
import checkMark from "assets/svgs/checkmark.svg";
import Dropdown from "app/components/Dropdown";
import { useSelector } from "react-redux";
import { selectTeamSetting, selectTicketStatus } from "app/redux/selector";
import { useDispatch } from "react-redux";
import { actions } from "../containers/Tickets/redux/slice";
import { getDefaultTicketFields } from "../helpers";
interface TicketStatusButtonProps {
  readonly onShowAddTask?: () => void;
  readonly defaultGroup?: TicketGroup;
  readonly groupBy?: string;
}
export const TicketStatusButton: FC<TicketStatusButtonProps> = ({defaultGroup,groupBy }) =>{
    const dispatch = useDispatch();
    const [open, setOpen] = useState<boolean>(false);
    const [selectedTypeId, setSelectedTypeId] = useState<string | null>(null);
    const ticketStatusList = useSelector(selectTicketStatus);
    const selectedOption = ticketStatusList && ticketStatusList?.find(option => option?._id === selectedTypeId);

    const handleSelect = (selected) => {
        dispatch(actions.setTicketFormValue({name: GroupByTypeEnum.STATUS,value: selected}));
        setSelectedTypeId(selected);
        setOpen(false);
    };

    useEffect(() => {
    if (!ticketStatusList?.length) return;

    // Default to first option
    let defaultId = ticketStatusList[0]?._id;
    // Override if groupBy is "status" and have a group
    if (groupBy === GroupByTypeEnum.STATUS && defaultGroup) {
        const resolved = getDefaultTicketFields(defaultGroup, GroupByTypeEnum.STATUS);
        const match = ticketStatusList.find((s) => s.name === resolved.status);
    if (match) defaultId = match._id;
  }
  setSelectedTypeId(defaultId);
  dispatch(actions.setTicketFormValue({ name: "status", value: defaultId }));
}, []);

    const menuItems = ticketStatusList && ticketStatusList?.map((option) => ({
        label: (
           <div className="cursor-pointer flex items-center justify-between py-2 text-sm text-secondary w-full">
            <div className="flex items-center gap-[8px] pt-1">
                <StatusIcon color={option?.color} />
                <span style={{ color: option?.color }}>{option.name}</span>
            </div>
            {selectedTypeId === option?._id && (
                <img src={checkMark} alt="selected" className="size-[20px]" />
            )}
            </div>
        ),
        action: () => handleSelect(option?._id),
    }));

    return (
        <Dropdown
            trigger={
                <button
                        className="flex flex-row items-center min-w-[28px] h-[28px] px-[6px] rounded-[4px] border border-[#E9ECF2] hover:bg-[#ECEEF2] hover:text-[#79808A] transition-all duration-200"
                    >
                    <CustomTooltip text="Set status" position="bottom">
                    <div className="flex items-center gap-1 min-w-[16px]">
                        {<StatusIcon color={selectedOption?.color} />}
                        {selectedOption && (
                            <span className="text-sm" style={{ color: selectedOption?.color }}>
                            {selectedOption?.name}
                            </span>
                        )}
                        </div>
                 </CustomTooltip>
                    </button>
            }
            menuItems={menuItems}
            align="start"
            className="min-w-[237px] max-h-[260px] py-2"
            projectInfoIcon={
                <div className="flex items-center gap-2 pl-4 pr-2 py-2 text-secondary text-sm font-semibold uppercase border-b border-[#E9ECF2]">
                    STATUSES
                </div>
            }
        />
    );
};
